'use strict';

var variables = require('./variables-1eb6495a.js');

const light = {
    root: {
        '&[role="option"]': {
            // apply the style in case <ListSubheader /> is used for grouping within <Select />
            color: variables.COLORS.TEXT_PRIMARY,
            lineHeight: 1.33,
            padding: "4px 12px",
            fontWeight: 600,
            fontSize: variables.SIZES.TEXT_SMALL,
            borderBottom: `solid 1px ${variables.COLORS.GREYSCALE_0_15}`,
            // workaround to prevent the <ListSubheader /> to be clickable when it is used for grouping within <Select />.
            // See issue: https://github.com/mui-org/material-ui/issues/18200
            pointerEvents: "none",
        },
    },
};

var MuiListSubheader = /*#__PURE__*/Object.freeze({
  __proto__: null,
  light: light
});

exports.MuiListSubheader = MuiListSubheader;
exports.light = light;
